import React from 'react';
import { Container, Box, Typography, Button } from '@mui/material';
import { Construction as ConstructionIcon } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { getDefaultRoute } from '../../utils/getDefaultRoute';

const UnderConstruction = () => {
  const navigate = useNavigate();
  const { user } = useAuth();

  const goHome = () => {
    navigate(getDefaultRoute(user?.role, user));
  };

  return (
    <Container maxWidth="sm">
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '80vh',
          textAlign: 'center',
        }}
      >
        <ConstructionIcon sx={{ fontSize: 80, color: 'text.secondary', mb: 2 }} />
        
        <Typography variant="h4" component="h1" gutterBottom>
          Under Construction
        </Typography>
        
        <Typography variant="body1" color="text.secondary" paragraph sx={{ mb: 4 }}>
          We are working hard to bring you this feature. Please check back later!
        </Typography>

        <Button variant="contained" onClick={goHome}>
          Back to Dashboard
        </Button>
      </Box>
    </Container>
  );
};

export default UnderConstruction;
